import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserLoginService } from '../Common/UserLoginService/userlogin.service';
import { UserPermissionService } from '../Common/UserPermission/userPermission.service';
import { UserPermissionReadByUserIdRequestDTO } from '../Common/UserPermission/userPermission.interface';
import { ensureNumber } from '../Shared/customFunctions/CustomFunctions';

@Injectable({
    providedIn: 'root'
})
export class RouteGuard implements CanActivateChild {

    userPermissionService = inject(UserPermissionService)
    toaster = inject(ToastrService)
    userLoginService = inject(UserLoginService)

    constructor(private router: Router) { }
    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        const User = this.userLoginService.User();

        // If subscription is fully expired (severity 1), block all navigation and redirect to payment page
        const expiredData = sessionStorage.getItem('expiredSubscriptionData');
        if (expiredData) {
            if (state.url.startsWith('/subscription-expired')) return true;
            this.router.navigate(['/subscription-expired']);
            return false;
        }

        // If subscription is active, block direct access to the expired page
        if (state.url.startsWith('/subscription-expired')) {
            this.router.navigate(['/']);
            return false;
        }

        const menulist = localStorage.getItem('menuList')?.split(',').filter(Boolean) ?? [];
        const pathSegments = state.url.split('?')[0].split('/').filter(Boolean); // removes empty segments
        const [moduleCode, pageCode] = pathSegments;


        let userPermissionData: UserPermissionReadByUserIdRequestDTO = {
            userId: User.userId,
            menuCode: pageCode ?? '',
            tenantId: ensureNumber(User.companyId),
            tenantBranchId: ensureNumber(User.loggedInBranchId),
            softwareId: 0
        }

        this.userPermissionService.UserPermission_readByUserId(userPermissionData).subscribe({
            next: (res) => {
                this.userPermissionService.UserPermissions.next([])
                this.userPermissionService.UserPermissions.next(res.items)

            }, error: (err) => {
                console.log(err);
                this.userLoginService.SignOutUser();
            }
        })



        if (route.routeConfig?.path === 'base') {
            console.log('Access granted for base route');
            return true;
        }

        // For routes like "/admin/roles"
        if (menulist.includes(moduleCode) && (!pageCode || menulist.includes(pageCode))) {
            console.log(`User has access to ${moduleCode}${pageCode ? '/' + pageCode : ''}`);
            return true;
        }

        if (menulist.length === 0) {
            this.userLoginService.SignOutUser();
            this.toaster.error('User Does Not Exist! Please Contact Admin.');
            return false;
        }

        console.log('Access denied to:', state.url);
        this.router.navigate(['/PageNotFound']);
        return false;
    }
}
